export const PERMISSION_GROUPS = {
  basic: {
    id: 'basic',
    name: '基础权限',
    level: 1,
    includes: [],
    permissions: ['view_prompts', 'favorite_prompts'],
  },
  premium: {
    id: 'premium',
    name: '高级权限',
    level: 2,
    includes: ['basic'],
    permissions: ['view_prompts', 'favorite_prompts', 'view_premium_prompts'],
  },
  contributor: {
    id: 'contributor',
    name: '贡献者',
    level: 3,
    includes: ['premium'],
    permissions: [
      'view_prompts',
      'favorite_prompts',
      'view_premium_prompts',
      'create_prompts',
      'edit_own_prompts',
    ],
  },
  admin: {
    id: 'admin',
    name: '管理员',
    level: 4,
    includes: ['basic', 'premium', 'contributor'],
    permissions: ['*'], // 所有权限
  },
} as const;

export type PermissionGroup = keyof typeof PERMISSION_GROUPS;

/**
 * 检查用户是否有权限访问指定的权限组
 */
export function hasPermission(
  userGroups: string[],
  requiredGroups: string[]
): boolean {
  if (requiredGroups.length === 0) return true;

  // 获取用户所有有效的权限组(包括继承的)
  const effectiveGroups = new Set<string>();
  userGroups.forEach((group) => {
    effectiveGroups.add(group);
    const groupConfig = PERMISSION_GROUPS[group as PermissionGroup];
    if (groupConfig) {
      groupConfig.includes.forEach((included) => effectiveGroups.add(included));
    }
  });

  // 检查是否有任何一个必需的权限组
  return requiredGroups.some((required) => effectiveGroups.has(required));
}

/**
 * 获取用户的所有有效权限组(包括继承的)
 */
export function getEffectivePermissions(userGroups: string[]): string[] {
  const effectiveGroups = new Set<string>();
  userGroups.forEach((group) => {
    effectiveGroups.add(group);
    const groupConfig = PERMISSION_GROUPS[group as PermissionGroup];
    if (groupConfig) {
      groupConfig.includes.forEach((included) => effectiveGroups.add(included));
    }
  });
  return Array.from(effectiveGroups);
}

